enum TeaserType {
  SIMPLE = 'simple',
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LANDSCAPE = 'landscape',
  LANDSCAPE_FULL_GRID = 'landscape-full-grid',
  STAGE = 'stage',
  HUB = 'hub',
  TOOLS = 'tools',
}
export default TeaserType;
